module.exports = __webpack_public_path__ + "fonts/la-solid-900.8c65fd3.eot";